import CheckCircleIcon from '@atlaskit/icon/core/check-circle';
import * as React from 'react';

export function SvgCheckCircleSmall() {
  return <CheckCircleIcon label="" testId="ads-refreshed-icon" />;
}
